import { useMutation, useQueryClient } from '@cd/react-query';
import { noop } from '@cd/utils';
import { postJSONPS } from '@cd/utils';
import { handleMutationResponse } from './coreUseFn';
import { useRef } from 'react';

/** usePostRequest :: disptach, {} */
export function usePostRequest({
	url,
	queryName,
	dispatch,
	login = false,
	successFn = noop,
	errorFn = noop
}) {
	const formRef = useRef({}); // [{ values, formFns }, setMutateParams]
	const queryClient = useQueryClient();
	const loginObj = login ? { login: true } : {};
	const { mutate, ...rest } = useMutation(
		values =>
			postJSONPS('POST', url, {
				body: JSON.stringify(values),
				...loginObj
			}),
		{
			onSuccess: handleMutationResponse({
				successFn,
				errorFn,
				dispatch,
				queryClient,
				queryName,
				formRef
			})
		}
	);

	return {
		...rest,
		/**
		 * Provide your own mutate function that accepts formFns
		 * @param {} values
		 * @param {*} formFns
		 * @returns
		 */
		mutate: (values, formFns) => {
			formRef.current = { values, formFns };
			return mutate(values);
		}
	};
}
